
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lektor/[...slug]",
      function () {
        return require("private-next-pages/lektor/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lektor/[...slug]"])
      });
    }
  